
import React from 'react';
import { ExternalLink } from 'lucide-react';

interface OpenPromoButtonProps {
  trackId: string;
}

const OpenPromoButton: React.FC<OpenPromoButtonProps> = ({ trackId }) => {
  // Handle opening the promo link directly
  const handleOpenPromo = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Make sure we have a valid track ID
    if (!trackId) {
      console.error("Cannot open promo: Invalid track ID");
      return;
    }
    
    // Track promo button click
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', 'OpenPromo', {
        track_id: trackId
      });
    }
    
    // Create the URL and open it in a new tab
    const downloadUrl = `/download?id=${trackId}`;
    console.log("Opening download URL:", downloadUrl);
    window.open(downloadUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleOpenPromo}
      className="bg-green-800 hover:bg-green-700 text-white flex items-center text-xs font-medium px-3 py-2 rounded-md"
      type="button"
    >
      <ExternalLink size={14} className="mr-1" />
      Open Promo
    </button>
  );
};

export default OpenPromoButton;
